import React from "react";
import type { IconType } from "react-icons";

/**
 * react-icons v5 types its icons as returning `ReactNode`, which TypeScript 4.x
 * refuses to treat as a JSX element. This thin wrapper renders any react-icons
 * icon through a component whose return type is a valid JSX element.
 */
const AppIcon = ({
  icon,
  size,
  color,
}: {
  icon: IconType;
  size?: number;
  color?: string;
}) => {
  const IconComponent = icon as unknown as React.FC<{
    size?: number;
    color?: string;
  }>;
  return <IconComponent size={size} color={color} />;
};

export default AppIcon;
